var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		showPlaceholderProductList: false,
		selectionHorizontalPlace: "#filter-box"
	},
	search: {
		enableSearch: !1,
		enableSuggestion: !1,
	},
	custom: {
		active_image_swap: !1
	}
};



/********************* CUSOTMIZE elments IDs and CLASSES************************************/

BCSfFilter.prototype.overwriteSettings = function () {

	this.selector = this.selector || {};
	this.defaultSettings = this.defaultSettings || {};
	this.template = this.template || {};
	this.class = this.class || {};

	// Selectors
	var sOptions = {
		filterWrapper: "#x--bc-sf-filter-wrapper",
		filterTree: "#filter-box-mobile .filter-tree-mobile",//"#x--bc-sf-filter-tree"
		filterTreeHorizontal: "#filter-box",//"#x--bc-sf-filter-tree-h" 
		filterTreeMobile: "#xxx--bc-sf-filter-tree-mobile", // mobile filter toggler not in use
		filterTreeMobileButton: "#x--bc-sf-filter-tree-mobile-button",
		filterOptionOpenValue: "bc-sf-filter-filter-option-open",
		filterOptionSubmitOpenValue: "bc-sf-filter-filter-option-s-open",
		products: "#products-grid",//#x--bc-sf-filter-products
		topSorting: "#x--bc-sf-filter-top-sorting",
		topSortingMobile: "#x--bc-sf-filter-top-sorting-mobile",
		pagination: "#pagination",
		bottomPagination: "#pagination",
		topNotification: "#bc-sf-filter-top-notification"
	};
	this.selector = $.extend({}, this.selector, sOptions);

	// Classes
	sOptions = {
		filterOption: "bc-sf-filter-option-block",
		filterBlockTitle: "xx-bc-sf-filter-block-title",
		filterBlockContent: "xx-bc-sf-filter-block-content",
		selectFilterOptionButton: "bc-sf-filter-select-button",
		filterOptionItem: "bc-sf-filter-option-item",
		filterOptionLabel: "bc-sf-filter-option-label",
		filterOptionRange: "bc-sf-filter-option-range",
		filterRefineWrapper: "x--bc-sf-filter-selection-wrapper",
		filterSelectedItems: "x--bc-sf-filter-selected-items",
		filterSelectedItemsMobile: "x--bc-sf-filter-selected-items-mobile",
		filterOptionHidden: "bc-sf-filter-option-hidden",
		filterOptionOpenList: "bc-sf-filter-option-open-list",
		filterOptionCloseList: "bc-sf-filter-option-close-list",
		filterOptionMultipleList: "bc-sf-filter-option-multiple-list",
		filterOptionViewMore: "bc-sf-filter-option-view-more",
		filterOptionViewLess: "bc-sf-filter-option-view-less",
		filterOptionViewMoreList: "bc-sf-filter-view-more-list",
		clearButton: "bc-sf-filter-clear",
		clearAllButton: "clear-all",//"bc-sf-filter-clear-all",
		collectionHeader: "bc-sf-filter-collection-header",
		collectionDescription: "bc-sf-filter-collection-description",
		filterOptionTooltip: "bc-sf-filter-option-tooltip",
		mobileButtonOpen: "bc-sf-filter-tree-mobile-button-open",
		mobileDetectiOS: "bc-sf-filter-mobile-detect-ios"
	};
	this.class = $.extend({}, this.class, sOptions);

	// Templates
	sOptions = {
		filterOptionWrapper: '<li filterOptionWrapper class="{{class.filterOption}} {{blockTypeClass}} {{blockId}}" data-block-id="{{blockId}}">' +
			'<a href="" class="uk-accordion-title">{{blockTitle}}<i class="icon-thin-down"></i></a>' +
			'<div class="uk-accordion-content">' +
			'<div class="filter-group {{class.filterBlockContent}}">{{blockContent}}</div>' +
			'</div>{{clearButton}}' +
			'</li>',

		filterOptionHorizontalWrapper: '<li class="{{blockTypeClass}} {{blockId}}" data-block-id="{{blockId}}">' +
			'<a href="javascript:;" tabindex="0" role="button">{{count}}{{blockTitle}}<i class="icon-thin-down"></i></a>' +
			'<div id={{blockContentId}} class="uk-box-shadow-xlarge uk-dropdown" data-uk-dropdown="mode:click;animation:uk-animation-slide-bottom-small; duration: 300;delay-hide:50">' +
			'<div class="uk-nav uk-dropdown-nav {{class.filterBlockContent}}">' +
			'<div class="filter-group {{class.filterBlockContent}}-inner">{{blockContent}}{{btnApply}}</div>' +
			'</div></div></li>',

		filterOptionLabel: '<span filterOptionLabel class="bc-sf-filter-option-value">{{itemValue}}</span>',

		filterOptionSingleList: '<ul class="bc-sf-filter-option-single-list">{{itemList}}</ul>',
		filterOptionSingleListItem: '<li><a href="{{itemLink}}" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}" {{itemChecked}}>{{itemLabel}}</a></li>',

		filterOptionMultipleList: '<div filterOptionMultipleList class="uk-margin-small">{{itemList}}</div>',
		filterOptionMultipleListItem: '<label filterOptionMultipleListItem><input type="checkbox" onClick="{{itemFunc}}"	class="uk-checkbox {{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}" {{itemChecked}}>{{itemLabel}}</label>',

		filterOptionBox: '<ul filterOptionBox class="bc-sf-filter-option-box">{{itemList}}</ul>',
		filterOptionBoxItem: '<li filterOptionBoxItem ><a href="javascript:;" onClick="{{itemFunc}}" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{itemSelected}}">{{itemLabel}}</a></li>',

		filterRefineWrapper: '<div class="{{class.filterRefineWrapper}}">' +
			'<div class="uk-flex uk-flex-between uk-flex-middle">' +
			'<span class="meta">Refine by:</span><a href="#" class="uk-button uk-button-text clear-all bc-sf-filter-clear-all" onclick="clearAllFilterOptions(event)">Clear all</a>' +
			'</div>' +
			'<div class="filter-group tags {{class.filterSelectedItems}}">{{selectedItems}}</div>' +
			'</div>',
		filterRefineItem: '<span class="selected-item {{class.filterOptionLabel}}"><a data-tag class="filter-tag" href="{{itemLink}}">{{itemLabel}}<i class="icon-error"></i></a></span>',

		filterRefineHorizontalWrapper: '<div class="active-filters uk-grid">'+
											'<div class="meta uk-visible@m bc-sf-filter-total-product"></div>' + 
											'<div class="bc-sf-filter-pc {{class.filterRefineWrapper}}">' +
												'<div class="filter-group tags {{class.filterSelectedItems}}">{{selectedItems}}</div>' +
											'</div>' +
											'<div><a href="#" class="clear-all uk-button uk-button-text" onclick="clearAllFilterOptions(event)"><small>Clear All Filters</small></a></div>' +
										'</div>',
		filterRefineHorizontalItem: '<span class="selected-item {{class.filterOptionLabel}}"><a data-tag class="filter-tag" href="{{itemLink}}">{{itemLabel}}<i class="icon-error"></i></a></span>',

		filterTreeMobileButton: '<button id="x--bc-sf-filter-tree-mobile-button" class="uk-button uk-button-secondary" type="button">{{label}}</button>',
		filterOptionViewMore: '<div class="bc-sf-filter-option-view-more"><a href="javascript:;" aria-label="{{label.viewMore}}" onclick="viewMoreFilterOption(this)">{{label.viewMore}}</a></div>',
		filterOptionViewLess: '<div class="bc-sf-filter-option-view-less"><a href="javascript:;" aria-label="{{label.viewLess}}" onclick="viewLessFilterOption(this)">{{label.viewLess}}</a></div>',
		clearAllButton: '<a href="javascript:;" data-clear-all-filters aria-label="{{label.clearAll}}" class="uk-button uk-button-text {{class.clearAllButton}}" onClick="clearAllFilterOptions(event)">{{label.clearAll}}</a>',
		btnLoadPreviousPageTemplate: '<div id="bc-sf-filter-btn-load-previous-page"><a href="javascript:void(0)" aria-label="{{label.loadPreviousPage}}" class="js-bc-sf-filter-btn-load-previous-page">{{label.loadPreviousPage}}</a></div>',
		loading: '<div id="bc-sf-filter-loading"></div>',
		error: '<div id="bc-sf-filter-error">{{content}}<div class="btn-wrapper"><button>Close</button></div></div>',
		noResult: '<div id="bc-sf-filter-message" class="uk-alert uk-alert-warning"><p>{{content}}</p></div>'
	};

	this.template = $.extend({}, this.template, sOptions);
};



/*========================== NOVI ============================*/

// Changed
BCSfFilter.prototype.collapseFilterOption = function () { return; };


BCSfFilter.prototype.afterGetFilterData = function (a, b) {
	if (!this.pageOverFallback(a)) {
		if (this.hideLoading(), this.removePlaceholderForFilterTree(), ["infinite", "load_more"].indexOf(this.getSettingValue("general.paginationType")) > -1 && this.getSettingValue("general.showLoadMoreLoading") && !1 === this.getSettingValue("general.showLoading") && this.hideLoadMoreLoading(), "collection" == b) {
			var c = bcsffilter.class.filterOptionOpenList,
				d = bcsffilter.class.filterOptionCloseList;
			jQ("." + c).length > 0 && jQ("." + c).remove(),
				jQ("." + d).length > 0 && jQ("." + d).remove()
		}
		a.hasOwnProperty("errorMessage") || (this.catchError(a, b), this.buildAll(a, this.queryParams.build_filter_tree, b))
	}
};

BCSfFilter.prototype.buildFilterSelectionMobile = function () {
	var a = [], b = this;
	if (jQ(this.selector.filterTree + " ." + this.class.filterOption).each(function () {
		var c = jQ(this).data("type"), d = jQ(this);
		if (!b.isCollectionParam(c)) {
			var e = [], f = jQ(this).attr("data-id"), g = jQ(this).attr("data-display-type"),
				h = jQ(this).attr("data-type"), i = jQ(this).attr("data-select-type"),
				j = jQ(this).attr("data-prefix");
			if (j = void 0 !== j && null !== j && !1 !== j ? j.replace(/\\/g, "") : "", "range" !== g) {
				if (jQ(this).find("a.selected").each(function () {
					a.push(f + "=" + jQ(this).attr("data-value"))
				}), b.queryParams.hasOwnProperty(f) && b.queryParams[f] && b.queryParams[f].length) {
					var k = b.queryParams[f];
					Array.isArray(k) || (k = [k]);
					for (var l = 0; l < k.length; l++) {
						var m = b.customizeFilterOptionLabel(k[l], j, h);
						e.push(m), "single" !== i && a.push(f + "=" + encodeURIParamValue(k[l]))
					}
				}
				a = a.filter(function (a, b, c) {
					var e = !0;
					if (a.length && (iValue = a.split("="), iValue.length > 1)) {
						var f = d.find('a[data-id="' + iValue[0] + '"][data-value="' + iValue[1] + '"]');
						f.length && !f.hasClass("selected") && (e = !1)
					}
					return c.indexOf(a) === b && e
				})
			} else if (jQ(this).find("." + b.class.filterOptionRange + "-slider").hasClass("selected")) {
				var n = jQ(this).find("." + b.class.filterOptionRange + "-slider").attr("data-value"), m = "";
				if (n.length) {
					if (jQ(this).find("." + b.class.filterOptionRange + "-slider").hasClass("bc-sf-filter-option-advanced-range-slider")) {
						var o = jQ(this).data("filter-option"), j = jQ(this).data("prefix") || "";
						j = j.replace(/\\/g, "");
						var p = n.split(","), q = [];
						if (o && o.hasOwnProperty("values")) var q = o.values.map(function (a) {
							return a.key
						});
						var r = q.length ? b.getAdvancedRangeSelectedValues(p, q) : [p[0], p[p.length - 1]];
						m = r[0].toString().replace(j, ""), p.length > 1 && (m += " - " + r[1].toString().replace(j, ""));
						for (var l in p) a += "&" + f + "=" + encodeURIParamValue(p[l])
					} else {
						var p = n.split(":");
						if ("price" == c) {
							var s = b.formatMoney(100 * p[0]), t = b.formatMoney(100 * p[1]);
							b.getSettingValue("general.removePriceDecimal") && (s = b.removeDecimal(s), t = b.removeDecimal(t));
							var m = s + " - " + t
						} else var m = p[0] + " - " + p[1];
						a.push(f + "=" + encodeURIParamValue(n))
					}
					e.push(m)
				}
			}
			jQ(this).find("." + b.class.filterBlockTitle + " p").remove(), jQ(this).find("." + b.class.filterBlockTitle).append('<p class="' + b.class.filterSelectedItemsMobile + '">' + e + "</p>")
		}
	}), a.length && (a = "&" + a.join("&")), this.isSearchPage) {
		var c = this.getSearchTerm();
		null !== c && "" != c && (a += "&" + this.searchTermKey + "=" + c)
	}
	jQ("#bc-sf-filter-params").remove(), jQ(this.selector.filterTree).append('<input type="hidden" id="bc-sf-filter-params" value="' + a + '"/>')
};


BCSfFilter.prototype.addFilterTreeItem = function (a, b, c, d) {

	var activeFilters = a.indexOf("x--bc-sf-filter-selected-items");

	if (a = jQ.parseHTML(a), d != this.selector.filterTree && d != this.selector.filterTreeHorizontal && jQ(d).html(""), void 0 === d) {
		var d = "vertical" == c ? this.selector.filterTree : this.selector.filterTreeHorizontal;
		if ("vertical" != c && activeFilters < 0) {
			d = this.selector.filterTreeHorizontal + " #x--bc-sf-filter-tree-h";
		}
	}

	void 0 !== b && "before" == b ? jQ(d).prepend(a) : jQ(d).append(a)
};


BCSfFilter.prototype.afterBuildFilterTree = function (a) {

	jQ(this.selector.filterTree + "> li").wrapAll('<ul class="uk-accordion filter-groups" data-uk-accordion id="bc-sf-filter-options-wrapper"></ul>'),
		//this.buildFilterOptionBoxStyle(), 
		this.triggerOpenHorizontalFilterEvent();
	//this.buildFilterShowMore(), 
	//this.checkIsFullWidthMobile() || this.collapseFilterOption()
};


BCSfFilter.prototype.buildFilterSelection = function (a) {

	var b = this.buildFilterSelectionData(a), c = b[0], d = b[1], e = this.buildClearAllButton();

	if ("" != c) {
		var f = this.getTemplate("filterRefineWrapper");
		f = f.replace(/{{label}}/g, this.getSettingValue("label.refine")),
			f = f.replace(/{{selectedItems}}/g, c),
			f = this.buildFilterTreeClass(f),
			this.addFilterTreeItem(f, "before", "vertical");
		//jQ(this.selector.filterTree).find("." + this.class.filterRefineWrapper + " ." + this.class.filterBlockTitle).append(e)
	}

	var g = this.getSettingValue("general.selectionHorizontalPlace");
	var h = this.getTemplate("filterRefineHorizontalWrapper");

	if ("#filter-box" != g && jQ(g).empty(), "" != d) {

		h = h.replace(/{{label}}/g,
			this.getSettingValue("label.refine")),
			h = h.replace(/{{selectedItems}}/g, d),
			h = this.buildFilterTreeClass(h),
			jQ(this.selector.filterTreeHorizontal + " .active-filters").remove();
			"top" == this.getSettingValue("general.refineByHorizontalPosition") ?
				this.addFilterTreeItem(h, "before", "horizontal", g) :
				this.addFilterTreeItem(h, "after", "horizontal", g);//, jQ(".bc-sf-filter-pc." + this.class.filterRefineWrapper).append(e)
	}else if(d == ""){

		h = h.replace(/{{label}}/g, ""),
		h = h.replace(/{{selectedItems}}/g, ""),
		h = this.buildFilterTreeClass(h);

		jQ(this.selector.filterTreeHorizontal + " .active-filters").remove();
			"top" == this.getSettingValue("general.refineByHorizontalPosition") ?
				this.addFilterTreeItem(h, "before", "horizontal", g) :
				this.addFilterTreeItem(h, "after", "horizontal", g);

		jQ(this.selector.filterTreeHorizontal + " .active-filters .bc-sf-filter-total-product ").html("");
		jQ(this.selector.filterTreeHorizontal + " .active-filters .x--bc-sf-filter-selection-wrapper + div").remove();
		jQ(this.selector.filterTreeHorizontal + " .active-filters .x--bc-sf-filter-selection-wrapper").remove();
	}
};


BCSfFilter.prototype.buildClearEvent = function (a) {
	var b = this;
	jQ("." + this.class.filterSelectedItems + " [data-tag]").on("click", function (a) {
		jQ("#" + b.selector.filterOptionOpenValue).val(null),
			a.preventDefault(),
			b.internalClick = !0;
		var c = jQ(this).data("tag") ? jQ(this).data("tag") : jQ(this).attr("href");
		b.onChangeData(c, "clearFilterOptionItem")
	})
};


BCSfFilter.prototype.buildMouseUpEvent = function (a) {
	var b = this;
	jQ(document).mouseup(function (c) {
		var d = jQ(b.selector.filterTreeHorizontal).find("." + b.class.filterBlockContent);
		d.is(c.target) || 0 !== d.has(c.target).length || b.buildSubmitEvent(a, !0, c)
	})
};


//changed
BCSfFilter.prototype.buildFilterOptionItem = function (a, b, c, d, e, f, g, h, i, j, k) {

	var l = !!j.hasOwnProperty("keepValuesStatic") && j.keepValuesStatic;
	if ("review_ratings" == d && "text" == this.getSettingValue("general.ratingSelectionStyle"))
		var m = this.getReviewRatingsLabel(i.from);
	else
		var m = this.customizeFilterOptionLabel(b, j.prefix, d);

	if (!0 === l) var n = null; else var n = i.hasOwnProperty("doc_count") ? i.doc_count : 0;

	if (a = a.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(b, n, j)), a = a.replace(/{{itemLink}}/g, this.buildFilterOptionLink(e, c, d, g, h, l)), a = a.replace(/{{itemValue}}/g, encodeURIParamValue(c)), a = a.replace(/{{itemTitle}}/g, m), "vertical" == k || "both" == k || "single" == h)
		var o = "onInteractWithFilterOptionValue(event, this, '" + d + "', '" + g + "', '" + h + "', '" + l + "')";
	else if (this.getSettingValue("general.requestInstantly") || "collection" == d)
		var o = "onInteractWithFilterOptionValue(event, this, '" + d + "', '" + g + "', '" + h + "', '" + l + "')";
	else
		var o = "onSelectFilterOptionItem(event, this)";

	a = a.replace(/{{itemFunc}}/g, o);
	if (this.checkFilterOptionSelected(e, c, d, g)) {
		a = a.replace(/{{itemSelected}}/g, "selected");
		a = a.replace(/{{itemChecked}}/g, ' checked="true" ');
	} else {
		a = a.replace(/{{itemSelected}}/g, "");
		a = a.replace(/{{itemChecked}}/g, "");
	}

	var p = jQ(a);
	return p.children().attr({
		"data-id": e,
		"data-value": encodeURIParamValue(c),
		"data-parent-label": f,
		"data-title": m,
		"data-count": n
	}), p.find("a").length > 0 && p.find("a").attr("aria-label", m), "review_ratings" == d && "text" == this.getSettingValue("general.ratingSelectionStyle") && p.children().attr("aria-label", m), this.getSettingValue("general.enableSeo") && "collection" != d && p.children().attr("rel", "nofollow"), "collection" == d && p.children().attr("data-collection-scope", i.key), jQ(p)[0].outerHTML
};

/* Changed */
BCSfFilter.prototype.buildFilterOption = function (a, b, c) {

	var d = b.label,
		e = this.class.filterOption + "-" + this.slugify(d),
		f = "vertical" == c ? this.getTemplate("filterOptionWrapper") : this.getTemplate("filterOptionHorizontalWrapper"),
		f = f.replace(/{{blockTitle}}/g, d),
		f = f.replace(/{{blockTitleId}}/g, this.class.filterBlockTitle + "-" + this.slugify(d)),
		f = f.replace(/{{blockTypeClass}}/g, this.class.filterOption + " " + this.class.filterOption + "-" + b.displayType),
		f = f.replace(/{{blockId}}/g, e),
		f = f.replace(/{{blockContent}}/g, a),
		f = f.replace(/{{blockContentId}}/g, this.class.filterBlockContent + "-" + this.slugify(d)),
		f = f.replace(/{{btnApply}}/g,
			"collection" == b.filterType || "review_ratings" == b.filterType ? "" : '<button class="' + this.class.selectFilterOptionButton + ' uk-button uk-button-secondary uk-button-small uk-width-1" data-id="' + e + '">' + this.getSettingValue("label.apply") + "</button>"),
		f = f.replace(/{{tooltip}}/g, this.buildFilterOptionTooltip(b));

	var g = "", h = "vertical" == c ? this.getSettingValue("label.clear") : this.getSettingValue("label.clearAll");


	if (this.queryParams.hasOwnProperty(b.filterOptionId) && this.queryParams[b.filterOptionId]) {
		f = f.replace(/{{count}}/g, '<span data-count-active-filters class="count">' + this.queryParams[b.filterOptionId].length + "</span>");
	} else {
		f = f.replace(/{{count}}/g, "");
	}

	if (this.queryParams.hasOwnProperty(b.filterOptionId) &&
		this.queryParams[b.filterOptionId] &&
		(g = '<a href="javascript:;" aria-label="' + this.getSettingValue("label.clear") + '" class="clear-all uk-button uk-button-text ' + this.class.clearButton + '" onClick="clearFilterOption(event, this, \'' + b.filterOptionId + "')\">" + h + "</a>"), f = f.replace(/{{clearButton}}/g, g), "" !== (f = this.buildFilterTreeClass(f))) {
		var i = jQ(f);
		i.attr({
			"data-id": b.filterOptionId,
			"data-type": b.filterType,
			"data-display-type": b.displayType,
			"data-select-type": b.selectType,
			"data-title": d,
			"data-prefix": b.prefix
		});
		//var j = !!b.hasOwnProperty("isCollapseMobile") && b.isCollapseMobile;
		//this.getSettingValue("general.collapseOnMobileByDefault") && (j = !0), i.attr("data-collapse-mobile", j);
		var k = null;
		if (["list", "box", "swatch"].indexOf(b.displayType) > -1 &&
			(k = "scrollbar"), b.hasOwnProperty("showMoreType") &&
			b.showMoreType &&
			(k = b.showMoreType), "" != this.getSettingValue("general.showMoreType") &&
			["list"].indexOf(b.displayType) > -1 &&
			(k = this.getSettingValue("general.showMoreType")), k &&
			i.attr({ "data-show-more-type": k }), this.getSettingValue("general.requestInstantly") &&
			i.find("." + this.class.selectFilterOptionButton).hide(), b.hasOwnProperty("useAndCondition") &&
			b.useAndCondition &&
			i.attr("data-and-condition", !0), b.hasOwnProperty("showExactRating") &&
			b.showExactRating &&
			i.attr("data-exact-rating", !0), i.attr("data-filter-option", JSON.stringify(b)), this.queryParams.hasOwnProperty(b.filterOptionId) &&
			this.queryParams[b.filterOptionId] &&
			(!c || "vertical" != c)) {
			var l = this.queryParams[b.filterOptionId].map(function (a) {
				return encodeURIParamValue(a)
			});
			i.attr("data-selected", JSON.stringify(l));
			if (i.data("selected") == 'selected') {
				i.prop("checked", true);
			} else {
				i.prop("checked", false);
			}
		}

		this.addFilterTreeItem(jQ(i)[0].outerHTML, "after", c),
			this.checkShowFilterOption(b) || jQ("." + e).addClass(this.class.filterOptionHidden)
	}
};

/* Changed */
BCSfFilter.prototype.beforeBuildFilterTree = function (a) {
	return jQ(this.selector.filterTree).html("").attr("aria-live", "polite"), jQ(this.selector.filterTreeHorizontal + ' li:not(.dont-touch)').remove().attr("aria-live", "polite"), a = this.removeProductTypeOptionInTypePage(a), a = this.prepareAdvancedRangeSlider(a)
};

/* Changed */
BCSfFilter.prototype.buildApplyEvent = function (a) {
	var b = this;
	jQ("." + this.class.selectFilterOptionButton).on("click", function (c) {
		b.buildSubmitEvent(a, !0, c)
	})
};

// Changed
BCSfFilter.prototype.buildSubmitEvent = function (a, b, c) {

	var _this = this;

	var d = jQ(_this.selector.filterTreeHorizontal).find("." + _this.class.filterBlockContent).filter(function () {
		//return "block" == jQ(this).css("display")
		return jQ(this).parent().hasClass("uk-open");
	}).eq(0)

	var e = jQ(d[0]).parent().parent(); // <---------- Changed

	jQ("#" + _this.selector.filterOptionOpenValue).val(jQ(d[0]).parent().attr("id"));
	var f = e.data("type"),
		g = e.data("display-type"),
		h = e.data("select-type"),
		i = e.attr("data-id"),
		j = [];

	j = (jQ(d).parent().parent().data("selected") || []).filter(function (a) {
		return a.length > 0
	});

	var m = _this.buildSubmitLink(i, j, f, g, h);

	!1 !== m &&
		!0 === _this.selectFilter &&
		(jQ("#" + _this.selector.filterOptionSubmitOpenValue).val(jQ(d[0]).parent().attr("id")), _this.internalClick = !0, _this.onChangeData(m, f, j, i));

	var n = jQ(_this.selector.filterTreeHorizontal).find("." + _this.class.filterBlockTitle);
	(!b || b && !n.is(c.target) && 0 === n.has(c.target).length) && (jQ(_this.selector.filterTreeHorizontal).find("." + _this.class.filterBlockTitle).children("a").removeClass("selected"))
};

// Changed
BCSfFilter.prototype.buildSubmitLink = function (a, b, c, d, e) {

	var f = newParamValue = "";
	if (this.queryParams.hasOwnProperty(a)) {
		for (var g = 0; g < this.queryParams[a].length; g++) f += "&" + a + "=" + encodeURIParamValue(this.queryParams[a][g]);
	}
	for (var h = 0; h < b.length; h++) {
		newParamValue += "&" + a + "=" + b[h];
	}
	if (f != newParamValue) {
		if ("" != f) var i = window.location.href.replace(f, newParamValue); else {
			var i = window.location.href;
			0 === window.location.search.length ? i += "?_=" + this.prefix : (i = window.location.href, this.queryParams.hasOwnProperty("_") || (i += "&_=" + this.prefix)), i += newParamValue
		}
		var j = "&" + a + "_and_condition=true";
		if (-1 == i.indexOf(j)) {
			jQ('[data-id="' + a + '"]').attr("data-and-condition") && (i += j)
		} else {
			-1 == i.indexOf(a + "=") && (i = i.replace(j, ""));
		}
		return i = removePageParamFromUrl(i), i = this.customizeSubmitLink(i, a, b, c, d, e)
	}
	return !1
};


/* ========================== END NOVI =========================== */

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

function onSelectFilterOptionItem(a, b) {
	if (jQ(b).data("count") > 0) {
		bcsffilter.selectFilter = !0;
		var c = jQ(b).data("value").toString(),
			d = jQ(b).parents("." + bcsffilter.class.filterOption).data("selected") || [];

		if (jQ(b).hasClass("selected")) {
			jQ(b).parent().children().removeClass("selected");
			jQ(b).parent().children().prop("checked", false);
			d.length && d.splice(d.indexOf(c), 1); // Remove element from an array
		} else {
			jQ(b).parent().children().addClass("selected");
			jQ(b).parent().children().prop("checked", true);
			d.push(c);
		}
		d = d.filter(function (a) { return a.length > 0 });
		jQ(b).parents("." + bcsffilter.class.filterOption).attr("data-selected", JSON.stringify(d));
	}
}


function prepareShopifyData(data) {


	// Displaying price base on the policy of Shopify, have to multiple by 100
	soldOut = !data.available; // Check a product is out of stock
	onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	priceVaries = data.price_varies || data.tags.includes('price-varies'); // Check a product has many prices
	data['price_varies'] = priceVaries;
	// Convert images to array
	images = data.images_info;
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	/* if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam('variant');
		});
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	} */

	data.json.product_type = data.product_type;

	return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

// Do not remove this method!!!
BCSfFilter.prototype.buildFilterTreeMobileButton = function (a) {
	return;
};

/************************** BUILD PRODUCT LIST **************************/

BCSfFilter.prototype.buildProductList = function (a, b) {

	(
		0 == this.loadProductFirst ||
		this.isTagPage() ||
		this.isTypePage() ||
		"best-selling" == this.defaultSorting ||
		1 == this.getSettingValue("general.productAndVariantAvailable") ||
		1 == this.loadProductFirst && ("init" != b) ||
		1 == this.getSettingValue("general.sortingAvailableFirst")
	) &&
	(a = this.prepareProductData(a),
		this.getSettingValue("general.loadProductFromLiquid") ?
			this.buildProductListDataFromLiquid(a, b) :
			(this.buildProductListData(a, b), this.buildExtrasProductList(a, b))
	)
};

// Build Product Grid Item / Product Card
BCSfFilter.prototype.buildProductGridItem = function (data, index, total) {

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;
	// Customize API data to get the Shopify data
	data = prepareShopifyData(data);
	// Add Custom class
	var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
	var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
	var c = index;

	// Check if all products are gift vouchers
	var allVouchers = false; 
	if(document.querySelectorAll("#x--bc-sf-filter-wrapper.gift-collection").length > 0){
		allVouchers = true;
	}
	
	// Index starts from 1
	index = index - 1;
	//
	var modulo5 = index % 5,
		modulo10 = index % 10,
		next_modulo5 = (index + 1) % 5,
		next_modulo10 = (index + 1) % 10,
		prev_modulo10 = (index - 1) % 10,
		next_big = false,
		next_big_modulo10 = (index + 2) % 10,
		open__card_group = false,
		close__card_group = false,
		group_opened = false,
		exp1,
		prefix = "",
		suffix = "",
		large_image = false;

	next_big = next_big_modulo10 == 0 ? true : false;

	if (modulo10 != 0 && (prev_modulo10 == 0 || modulo5 == 0 && prev_modulo10 != 0)) {
		open__card_group = true;
		close__card_group = false;
	} else {
		open__card_group = false;
	}

	if (modulo5 != 0 && next_modulo5 == 0 && next_modulo10 != 0) {
		exp1 = true;
	} else {
		exp1 = false;
	}

	if (exp1 || modulo5 != 0 && next_big) {
		open__card_group = false;
		close__card_group = true;
	} else {
		close__card_group = false;
	}

	if (open__card_group) {
		group_opened = true;
		prefix = '<div><!-- open card group --><div class="card-group uk-grid uk-grid-xsmall">';
		suffix = '';
	}
	if (close__card_group || (index + 1) == total && group_opened == true) {
		suffix = '</div><!-- close card group --></div>';
		prefix = '';
		group_opened = false;
	}
	 
	if(index == 0){
		large_image = true;
	}else if(index%2 == 0){ // is even
		large_image = Math.floor((c-1)/5) === ((c-1)/5) ? true : false;
	}else{ // odd
		large_image = Math.floor(c/10) === (c/10) ? true : false;
	}

	if(allVouchers){
		large_image = false;
		suffix = '';
		prefix = '';
	}

	itemHtml = itemHtml.replace(/{{prefix}}/g, prefix);
	itemHtml = itemHtml.replace(/{{suffix}}/g, suffix);

	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

	// Add Label
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
	// Add TAG Label
	itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
	// Add Images
	itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data, large_image));
	// Add Price
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
	// itemActiveSwapClass
	var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
	itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

	// Add data json
	itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));
	itemHtml = itemHtml.replace(/{{itemSKU}}/g, buildSKU(data));

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{variantId}}/g, data.selected_or_first_available_variant.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
}


/************************** END BUILD PRODUCT LIST **************************/


/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

BCSfFilter.prototype.optimizeImage = function (a, b) {
	null === a && (a = bcSfFilterConfig.general.no_image_url);
	var t = [], tmp = '';

	for (var b = void 0 !== b ? b : "large", c = this.getSettingValue("general.imageExtension"),
		d = 0; d < c.length; d++) {
		if (a.indexOf("." + c[d] + "?") > -1) {
			for (var i in b) {
				tmp = a.replace("." + c[d] + "?", "_" + b[i] + "x" + b[i] + "." + c[d] + "?");
				if (b.length > 1) {
					tmp = tmp + " " + b[i] + "w";
				}
				t.push(tmp);
			}
		}
	}
	return t.join(",");
};


/**
 *  @todo check if we are rendering image in the Colour Collection
 */
function buildImages(data, large_image) {
	var html = '';
	var sizes = [480, 768, 960, 1024, 1200];
	// Build Main Image	
	var thumbUrl = bcsffilter.getFeaturedImage(data.images, [480]);
	var responsiveThumbUrl = bcsffilter.getFeaturedImage(data.images, sizes);

	html += '<img class="bc-sf-filter-product-item-main-image" ' +
		'data-src="' + thumbUrl + '" ' +
		'data-srcset="' + responsiveThumbUrl + '" ' +
		(large_image ? 'data-sizes="(min-width: 992px) 50vw,50vw" ': 'data-sizes="(min-width: 992px) 25vw,50vw" ' )   +
		'alt="" ' +
		'data-uk-cover ' +
		'data-uk-img />';
	return html;
}


function buildSKU(data){ 
	var parts = [], 
		sku = data.selected_or_first_available_variant.sku;

	if (data.product_type == "Ring") {
		sku = sku.substring(0, sku.lastIndexOf("-"));
	}else if(data.product_type == "Necklace" || data.product_type == 'Pendant'){
		parts = sku.split("-");
		for(var i = parts.length-1; i > 0; i--){
			// check if part is numeric
			if(!isNaN(parseFloat(parts[i])) && isFinite(parts[i])){
				parts.pop();
			}else{
				break;
			}
		}
		sku = parts.join("-");
	}else if (data.product_type == "Bangle"){
		parts = sku.split("-");
		parts.pop();
		sku = parts.join("-");
	}else if (data.product_type == "Gift Voucher"){ 
		sku = '';
	}

	sku = '<small class="product-sku">' + sku + '</small>';
	return sku;
}

function buildPrice(data) {

	var html = '';
	var firstVariant = data.selected_or_first_available_variant;

	if(data.tags.includes("POA") && (!firstVariant.inventory_management || (firstVariant.inventory_management && (firstVariant.inventory_quantity == 0 && firstVariant.inventory_policy == 'deny')))){
		html = theme.currencySign + "POA";
	}else{
		if (bcSfFilterConfig.custom.show_price) {
			if (data.product_type != "Gift Voucher"){
				if (onSale) {
					html += bcsffilter.formatMoney(data.price_min);
				} else {
					if (priceVaries || data.tags.includes("price-varies")) {
						html += '<span class="uk-margin-xsmall-right uk-text-muted">From</span>' + bcsffilter.formatMoney(data.price);
					}else{
						html += bcsffilter.formatMoney(data.price);
					}
				}
			}
		}
	}
	
	return html;
}


// @investigate
function buildLabels(data) {
	// Build Sold out label
	var soldOutLabel = '';
	if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
		soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
	}

	var newLabel = '';
	if (bcSfFilterConfig.custom.show_new_label && newProduct) {
		soldOutLabel = bcSfFilterTemplate.newLabelHtml.replace(/{{style}}/g, '');
	}

	// Build Sale label
	var saleLabel = '';
	if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
		saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
	}
	// Build Labels
	return soldOutLabel + saleLabel;
}


// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
	if (showall) {
		var tagLabel = '';
		if (data.tags) {
			for (var i = 0; i < data.tags.length; i++) {
				var tag = data.tags[i];
				if (tag.indexOf("pfs:label") !== -1) {
					var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
					tagLabel += preTagLabel;
				}
			}
		}
	} else {
		var tagLabel = '';
		if (data.tags) {
			for (var i = data.tags.length - 1; i >= 0; i--) {
				var tag = data.tags[i];
				if (tag.indexOf("pfs:label") !== -1) {
					var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
					tagLabel += preTagLabel;
					break;
				}
			}
		}
	}
	return tagLabel;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/


/************************** BUILD TOOLBAR **************************/


// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// Build Additional pagination info
	buildPaginationPageTotal({
		currentPage: currentPage,
		totalPage: totalPage,
		limit: this.queryParams.limit,
		totalProduct: totalProduct
	});

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		jQ(this.selector.pagination).html(paginationHtml);
	}
};

//
function buildPaginationPageTotal(data) {
	var _this = this;
	var html = "<small>Showing {{pNumStart}} - {{pNumEnd}} of {{pTotal}}</small>";
	var end = data.totalProduct < data.currentPage * data.limit ? data.totalProduct : data.currentPage * data.limit;

	html = html.replace(/{{pNumStart}}/g, (data.currentPage - 1) * data.limit + 1);
	html = html.replace(/{{pNumEnd}}/g, end);
	html = html.replace(/{{pTotal}}/g, data.totalProduct);
	jQ('.bc-sf-filter-total-product').html(html);
};


// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
				
		jQ(this.selector.topSorting).html('');
		jQ(this.selector.topSortingMobile).html('');

		var sortingArr = this.getSortingList();

		if (sortingArr) {
			var paramSort = this.queryParams.sort || '';

			// Build content
			var sortingItemsHtml = '', sortingItemsHtmlMobile = '';
			for (var k in sortingArr) {
				activeClass = '';
				if (paramSort == k) {
					activeClass = 'uk-active';
				}
				sortingItemsHtml += '<li class="' + activeClass + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				sortingItemsHtmlMobile += '<li><label><input ' + (activeClass ? "checked" : '') + ' data-sort="' + k + '" type="radio" name="sort-by" class="uk-radio uk-radio-alt" value="' + k + '"><span>' + sortingArr[k] + '</span></label></li>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			var htmlMobile = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtmlMobile);

			jQ(this.selector.topSorting).html(html);
			jQ(this.selector.topSortingMobile).html(htmlMobile);


			var labelSort = '';
			if (paramSort.length > 0) {
				var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
				labelSort = bcSfFilterConfig.label[labelHandle];
			} else {
				labelSort = bcSfFilterConfig.label.sorting;
			}

			jQ('#xx--bc-sf-filter-custom-sorting-dektop-wrapper button span').text(labelSort);
		}
	}
};

BCSfFilter.prototype.onChangeData = function (a, b, c, d) {
	this.updateApiParams(a);
	this.getFilterData(b);
	this.changeAddressBar(a, b, c);
};


BCSfFilter.prototype.showLoading = function () {
	(!this.isMobile() && this.getSettingValue("general.showLoading") || this.isMobile() && this.getSettingValue("general.showMobileLoading")) && (0 == jQ("#bc-sf-filter-loading").length && jQ("body").append(this.getTemplate("loading")), jQ("#bc-sf-filter-loading").show())
};


BCSfFilter.prototype.getFilterData = function (a, b) {

	function c(a, b) {
		var c = bcsffilter,
			b = void 0 !== b ? b : 0;
		c.showLoading(),
			c.buildPlaceholderProductList(a),
			c.beforeGetFilterData(a),
			c.prepareRequestParams(a),
			c.queryParams.callback = "BCSfFilterCallback",
			c.queryParams.event_type = a;
		var d = c.isSearchPage() ? c.getApiUrl("search") : c.getApiUrl("filter"), e = document.createElement("script");
		e.type = "text/javascript";
		var f = (new Date).getTime();
		e.src = d + "?t=" + f + "&" + jQ.param(c.queryParams),
			e.id = "bc-sf-filter-script",
			e.async = !0,
			e.addEventListener("error", function (d) {
				"function" == typeof document.getElementById(e.id).remove ? document.getElementById(e.id).remove() : document.getElementById(e.id).outerHTML = "", b < 3 ? (b++, c.getFilterData("resend", b)) : c.buildDefaultElements(a)
			}),
			document.getElementsByTagName("head")[0].appendChild(e), e.onload = function () {
				"function" == typeof document.getElementById(e.id).remove ? document.getElementById(e.id).remove() : document.getElementById(e.id).outerHTML = ""
			}
	}
	this.requestFilter(c, a, b)
}

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function () {
	var _this = this;
	// Desktop
	jQ('#xx--bc-sf-filter-custom-sorting-dektop-wrapper a').on("click", function (e) {
		e.preventDefault();
		onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));		
	});

	// Mobile
	jQ(this.selector.topSortingMobile + ' .custom-select input[type="radio"]').on('change', function(e){
		onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
	});
};


// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	/* start-initialize-bc-al */
	var self = this;
	var alEnable = true;
	if (self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != '') {
		alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
	}
	if (alEnable === true && typeof BCActionList !== 'undefined') {
		if (typeof bcActionList === 'undefined') {
			bcActionList = new BCActionList();
		} else {
			if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
				bcActionList.initFlag = false;
				bcActionList.alInit(bcSfFilterParams, bcAlParams);
			} else {
				bcActionList.alInit();
			}
		}
	}
	/* end-initialize-bc-al */
	// Call theme init function
	// if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
	//   $(theme.init);
	// }
	// End For List View
};


// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	var _this = this;

	/* var totalProduct = 'Showing -' + bcSfFilterConfig.label.items_with_count_other + " of <span>" + data.total_product + "</span>";
	if (data.total_product == 1) {
		totalProduct = 'Showing -' + bcSfFilterConfig.label.items_with_count_one + " of <span>" + data.total_product + "</span>";
	} */
	// jQ('.bc-sf-filter-total-product').html(totalProduct);

	// Prevent double tap on iOS
	/* this.isMobile() && jQ(".bc-sf-filter-product-item").find("a").on("touchstart", function () {
		isScrolling = !1
	}).on("touchmove", function () {
		isScrolling = !0
	}).on("touchend", function () {
		isScrolling || (window.location = jQ(this).attr("href"))
	});
 */
	// Fix image not loaded on mobile
	(this.isMobile() || null != navigator.userAgent.match(/iPad/i)) && (setTimeout(function () {
		jQ(".bc-sf-filter-product-item-image img").each(function () {
			var a = jQ(this).attr("src") + "3";
			jQ(this).attr("src", a)
		})
	}, 200), setTimeout(function () {
		jQ(".bc-sf-filter-product-item-image img").each(function () {
			var a = jQ(this).attr("src") + "3";
			jQ(this).attr("src", a)
		})
	}, 2e3));
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements = function () {
	var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
		isSafari = /Safari/.test(navigator.userAgent),
		isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type;
	if (!(isiOS && isSafari && isBackButton)) {
		var self = this, url = window.location.href.split("?")[0],
			searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : "";
		window.location.replace(url + "?view=bc-original" + searchQuery)
	}
};

function customizeJsonProductData(data) {

	//console.log("customizeJsonProductData", data);

	for (var i = 0; i < data.variants.length; i++) {
		var variant = data.variants[i];
		var featureImage = data.images.filter(function (e) {
			return e.src == variant.image;
		});
		if (featureImage.length > 0) {
			variant.featured_image = {
				"id": featureImage[0]['id'],
				"product_id": data.id,
				"position": featureImage[0]['position'],
				"created_at": "",
				"updated_at": "",
				"alt": null,
				"width": featureImage[0]['width'],
				"height": featureImage[0]['height'],
				"src": featureImage[0]['src'],
				"variant_ids": [variant.id]
			}
		} else {
			variant.featured_image = '';
		};
	};

	var self = bcsffilter;
	var itemJson = {
		"id": data.id,
		"title": data.title,
		"handle": data.handle,
		"vendor": data.vendor,
		"variants": data.variants,
		"url": self.buildProductItemUrl(data),
		"options_with_values": data.options_with_values,
		"images": data.images,
		"images_info": data.images_info,
		"available": data.available,
		"price_min": data.price_min,
		"price_max": data.price_max,
		"compare_at_price_min": data.compare_at_price_min,
		"compare_at_price_max": data.compare_at_price_max
	};
	return itemJson;
};

BCSfFilter.prototype.prepareProductData = function (data) {

	var countData = data.length;
	for (var k = 0; k < countData; k++) {
		data[k]['images'] = data[k]['images_info'];
		if (data[k]['images'].length > 0) {
			data[k]['featured_image'] = data[k]['images'][0]
		} else {
			data[k]['featured_image'] = {
				src: bcSfFilterConfig.general.no_image_url,
				width: '',
				height: '',
				aspect_ratio: 0
			}
		}
		data[k]['url'] = '/products/' + data[k].handle;
		var optionsArr = [];
		var countOptionsWithValues = data[k]['options_with_values'].length;
		for (var i = 0; i < countOptionsWithValues; i++) {
			optionsArr.push(data[k]['options_with_values'][i]['name'])
		}
		data[k]['options'] = optionsArr;
		if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {
			var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();

			function updateMultiCurrencyPrice(oldPrice, newPrice) {
				if (typeof newPrice != 'undefined') {
					return newPrice;
				}
				return oldPrice;
			}

			data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);
			data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);
			data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);
			data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);
		}
		data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;
		data[k]['price'] = data[k]['price_min'];
		data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
		data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];
		var firstVariant = data[k]['variants'][0];
		if (getParam('variant') !== null && getParam('variant') != '') {
			var paramVariant = data[k]['variants'].filter(function (e) {
				return e.id == getParam('variant')
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
		} else {
			var countVariants = data[k]['variants'].length;
			for (var i = 0; i < countVariants; i++) {
				if (data[k]['variants'][i].available) {
					firstVariant = data[k]['variants'][i];
					break
				}
			}
		}
		data[k]['selected_or_first_available_variant'] = firstVariant;
		var countVariants = data[k]['variants'].length;
		for (var i = 0; i < countVariants; i++) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]['variants'][i];
			var variantOptions = variant['merged_options'];
			if (Array.isArray(variantOptions)) {
				var countVariantOptions = variantOptions.length;
				for (var j = 0; j < countVariantOptions; j++) {
					var temp = variantOptions[j].split(':');
					data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
					data[k]['variants'][i]['option_' + temp[0]] = temp[1];
					variantOptionArr.push(temp[1])
				}
				data[k]['variants'][i]['options'] = variantOptionArr
			}
			data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
			data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100
		}
		data[k]['description'] = data[k]['content'] = data[k]['body_html'];
		if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {
			data[k]['tags'] = data[k]['original_tags'].slice(0);
		}
		data[k]['json'] = customizeJsonProductData(data[k]);
	}
	return data;
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
	if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
		jQ(this.selector.topShowLimit).html('');
		var numberList = this.getSettingValue('general.showLimitList');
		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = '';
			var arr = numberList.split(',');
			for (var k = 0; k < arr.length; k++) {
				showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
			}
			var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			jQ(this.selector.topShowLimit).html(html);
			// Set value
			jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
		}
	}
};
/************************** END BUILD TOOLBAR **************************/